const sampleDataForHosting = {
  tweets: [
    { _id: { topic: "film_tv_&_video", sentiment: "positive" }, count: 158 },
    { _id: { topic: "sports", sentiment: "positive" }, count: 103 },
    {
      _id: { topic: "celebrity_&_pop_culture", sentiment: "positive" },
      count: 80,
    },
    {
      _id: { topic: "diaries_&_daily_life", sentiment: "positive" },
      count: 77,
    },
    { _id: { topic: "music", sentiment: "positive" }, count: 46 },
    {
      _id: { topic: "news_&_social_concern", sentiment: "positive" },
      count: 37,
    },
    { _id: { topic: "sports", sentiment: "neutral" }, count: 34 },
    { _id: { topic: "film_tv_&_video", sentiment: "neutral" }, count: 28 },
    {
      _id: { topic: "news_&_social_concern", sentiment: "neutral" },
      count: 27,
    },
    { _id: { topic: "food_&_dining", sentiment: "positive" }, count: 17 },
    {
      _id: { topic: "celebrity_&_pop_culture", sentiment: "neutral" },
      count: 16,
    },
    { _id: { topic: "relationships", sentiment: "positive" }, count: 15 },
    {
      _id: { topic: "news_&_social_concern", sentiment: "negative" },
      count: 13,
    },
    {
      _id: { topic: "business_&_entrepreneurs", sentiment: "positive" },
      count: 12,
    },
    { _id: { topic: "family", sentiment: "positive" }, count: 12 },
    { _id: { topic: "film_tv_&_video", sentiment: "negative" }, count: 10 },
    { _id: { topic: "sports", sentiment: "negative" }, count: 9 },
    { _id: { topic: "fashion_&_style", sentiment: "positive" }, count: 6 },
    { _id: { topic: "music", sentiment: "neutral" }, count: 6 },
    { _id: { topic: "diaries_&_daily_life", sentiment: "neutral" }, count: 5 },
    { _id: { topic: "fitness_&_health", sentiment: "positive" }, count: 5 },
    { _id: { topic: "diaries_&_daily_life", sentiment: "negative" }, count: 5 },
    {
      _id: { topic: "celebrity_&_pop_culture", sentiment: "negative" },
      count: 4,
    },
    { _id: { topic: "gaming", sentiment: "positive" }, count: 4 },
    { _id: { topic: "arts_&_culture", sentiment: "neutral" }, count: 3 },
    { _id: { topic: "fitness_&_health", sentiment: "neutral" }, count: 3 },
    { _id: { topic: "arts_&_culture", sentiment: "positive" }, count: 3 },
    { _id: { topic: "food_&_dining", sentiment: "neutral" }, count: 2 },
    { _id: { topic: "fashion_&_style", sentiment: "neutral" }, count: 1 },
    { _id: { topic: "fitness_&_health", sentiment: "negative" }, count: 1 },
    { _id: { topic: "gaming", sentiment: "neutral" }, count: 1 },
    { _id: { topic: "science_&_technology", sentiment: "neutral" }, count: 1 },
    { _id: { topic: "gaming", sentiment: "negative" }, count: 1 },
    { _id: { topic: "food_&_dining", sentiment: "negative" }, count: 1 },
    { _id: { topic: "youth_&_student_life", sentiment: "negative" }, count: 1 },
    {
      _id: { topic: "learning_&_educational", sentiment: "negative" },
      count: 1,
    },
    { _id: { topic: "fashion_&_style", sentiment: "negative" }, count: 1 },
    {
      _id: { topic: "business_&_entrepreneurs", sentiment: "neutral" },
      count: 1,
    },
  ],
  replies: [
    {
      _id: { topic: "celebrity_&_pop_culture", sentiment: "positive" },
      count: 230,
    },
    { _id: { topic: "music", sentiment: "positive" }, count: 224 },
    {
      _id: { topic: "celebrity_&_pop_culture", sentiment: "neutral" },
      count: 119,
    },
    { _id: { topic: "music", sentiment: "neutral" }, count: 113 },
    {
      _id: { topic: "celebrity_&_pop_culture", sentiment: "negative" },
      count: 67,
    },
    { _id: { topic: "music", sentiment: "negative" }, count: 63 },
    { _id: { topic: "sports", sentiment: "neutral" }, count: 11 },
    { _id: { topic: "film_tv_&_video", sentiment: "positive" }, count: 10 },
    { _id: { topic: "film_tv_&_video", sentiment: "neutral" }, count: 10 },
    { _id: { topic: "film_tv_&_video", sentiment: "negative" }, count: 7 },
    { _id: { topic: "sports", sentiment: "negative" }, count: 6 },
    {
      _id: { topic: "news_&_social_concern", sentiment: "negative" },
      count: 5,
    },
    { _id: { topic: "sports", sentiment: "positive" }, count: 5 },
    {
      _id: { topic: "news_&_social_concern", sentiment: "positive" },
      count: 3,
    },
    { _id: { topic: "news_&_social_concern", sentiment: "neutral" }, count: 2 },
    { _id: { topic: "fitness_&_health", sentiment: "negative" }, count: 1 },
    { _id: { topic: "fashion_&_style", sentiment: "positive" }, count: 1 },
    {
      _id: { topic: "learning_&_educational", sentiment: "negative" },
      count: 1,
    },
    { _id: { topic: "youth_&_student_life", sentiment: "negative" }, count: 1 },
  ],
  engagement: [
    { likes_count: 3904801, retweets_count: 370725, replies_count: 89110 },
  ],
};

export default sampleDataForHosting;
